import { memo } from 'react';
import ClipCustomizerCaptionsGalleryPopup from './ClipCustomizerCaptionsGalleryPopup/ClipCustomizerCaptionsGalleryPopup';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { toggleCaptions, updateCaptionPreset } from '@/stores/clip';
import Toggle from '@/components/atoms/Toggle';

import IconButton from '@/components/atoms/Button/IconButton';
import EventBus from '@/libs/eventBus/eventBus';
import { CustomEvents } from '@/libs/eventBus/constants';

function ClipCustomizerCaptionsPopup({
  onEditCaptions,
  isFullRecordingEdit
}: {
  onTimeUpdate: (time: number, shouldPlay?: boolean) => void;
  onEditCaptions: () => void;
  isFullRecordingEdit: boolean;
}) {
  const { clipId, clipData } = useClipsContext();

  function triggerEditCaptions() {
    EventBus.dispatch(CustomEvents.OpenEditCaptions);
    onEditCaptions();
    EventBus.dispatch(CustomEvents.OpenCaptionsMenu);
  }

  const isAudiogramLayout = clipData.asset_metadata.layout === 'AUDIOGRAM';
  const captionsEnabled = !!clipData.asset_metadata.subtitle;

  const onToggleCaptions = () => {
    if (captionsEnabled) {
      toggleCaptions(clipId, false);
    } else {
      updateCaptionPreset(clipId, clipData.asset_metadata.caption_styles?.theme_preset || 'beast');
    }
  };

  return (
    <div className="flex h-[80vh] w-[23rem] flex-col overflow-y-auto rounded-lg border bg-white shadow">
      <div className="sticky top-0 z-10 flex items-center justify-between bg-white px-4 py-3">
        <div className="text-lg font-medium">Captions</div>
        <div className="flex items-center gap-2">
          {!isFullRecordingEdit && (
            <IconButton
              icon="IconPencil"
              size="small"
              onClick={triggerEditCaptions}
              trackingId="captions-menu-edit-captions"
              content="Edit Captions"
            />
          )}
          <Toggle
            onToggle={onToggleCaptions}
            disabled={isAudiogramLayout}
            on={captionsEnabled}
            title={captionsEnabled ? 'Disable Captions' : 'Enable Captions'}
          />
        </div>
      </div>
      <div className="flex flex-col">
        <ClipCustomizerCaptionsGalleryPopup
          onPresetSelect={presetName => updateCaptionPreset(clipId, presetName)}
          selectedPreset={captionsEnabled ? clipData.asset_metadata.caption_styles?.theme_preset : undefined}
        />
      </div>
    </div>
  );
}

export default memo(ClipCustomizerCaptionsPopup);
